import { ROLE_PERMISSION_LABEL } from "constants/common/permission";
import { PERMISSION_LABEL_VI } from "constants/locales/permission";
import { PermissionModuleKey } from "constants/types/permission";

export const numberWithCommas = (num: number | string) => {
  if (!num) return "0";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const serialize = (obj: any) => {
  let str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      const value = obj[p];
      if (Array.isArray(value)) {
        value
          .filter((item) => item !== undefined && item !== null && item !== "")
          .forEach((item) =>
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(item)),
          );
      } else if (value)
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(value));
    }
  return str.join("&");
};

export const getPermissionModuleNameVi = (moduleName: string): string => {
  const convertedModuleName = moduleName.toUpperCase();
  const key = convertedModuleName as PermissionModuleKey;

  // Trả về kết quả mapping, fallback về chính chuỗi ban đầu nếu truyền sai key
  return PERMISSION_LABEL_VI[key] || moduleName;
};

export const getRolePermissionVi = (role: string) => {
  const convertedRole = role.toLowerCase();
  const key = convertedRole as keyof typeof ROLE_PERMISSION_LABEL;

  return ROLE_PERMISSION_LABEL[key] || role;
};
